export const development = {
  ulf: 'https://www5.wipo.int/webcomponents/wipo-navbar/',
  atacUrl: 'https://patentscope.wipo.int/WipoTranslateBeta/widget/app.js',
  ulfNavBar: 'https://cdn.ipp-navbar.ipportal.dev.web1.wipo.int/wipo-navbar/',
  siteId: 'ulfQA',
};
